import { BaseDto } from '../models';

export const mapTimeColumn = (row: BaseDto) => {
    if (row.createdOn) {
        let createdDate = new Date(row.createdOn);
        let timeString = createdDate.toLocaleDateString('en-us');
        return timeString;
    }
};
